import type { PreloadFetchPolicy } from 'react-relay';
import listViewFormattingRulesHydrateJqlQueryParameters from '@atlassian/jira-relay/src/__generated__/RuleListHydrateJqlQuery.graphql';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type ViewProps = {
	cloudId: string;
	hydrateJql: string;
};

export const formatRulesEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "async-jwm-conditional-formatting" */ './ConditionalFormattingSidebarApp'
			),
	),
	getPreloadProps: ({ cloudId, hydrateJql }: ViewProps) => {
		return {
			queries: {
				listViewFormattingRulesHydrateJqlQuery: {
					parameters: listViewFormattingRulesHydrateJqlQueryParameters,
					variables: {
						cloudId,
						jql: hydrateJql,
					},
					options: {
						// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
						fetchPolicy: 'store-or-network' as PreloadFetchPolicy,
					},
				},
			},
		};
	},
});
